module.exports = __webpack_public_path__ + "static/media/Male.da43baf7.svg";